import * as React from 'react';
import './activityIndicator.styles.scss';
var loader = require('../../assets/images/loader-v2.gif');
var ActivityIndicator = function () {
    return (React.createElement("div", { className: "loading-overlay" },
        React.createElement("div", null,
            React.createElement("img", { className: "loader-img", src: loader, alt: "loader-icon" }))));
};
export default ActivityIndicator;
//# sourceMappingURL=activityIndicator.js.map